import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./lang/index";
import router from "./router";
import { isMobile } from "@/utils/utils";
import formatThous from "@/utils/utils";
import formatNumber from "@/utils/utils";
import timeAgo from "@/utils/utils";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/styles/index.scss";
import nav from "@/components/navBack/index.vue";
import Carousel from "@/components/carousel/carousel.vue";
import Popup from "@/components/pop/pop.vue";
import PopLang from "./components/popLang/popLang.vue";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
import store from "./store";

import { Loading } from "element-ui";

Vue.prototype.$loadComponent = Loading;

import Toast from "vue2-toast";
import "vue2-toast/lib/toast.css";

Vue.use(Toast, {
  position: "center",
});

Vue.component("navBack", nav);
Vue.component("Carousel", Carousel);
Vue.component("Popup", Popup);
Vue.component("PopLang", PopLang);

Vue.prototype.$isMobile = isMobile();
// Vue.prototype.$formatThous = formatThous;
// Vue.prototype.$formatNumber = formatNumber;

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

// 定义一个变量来存储当前加载的样式类型
let currentStyleType = null;

// 封装加载样式的函数
async function loadStyle() {
  if (isMobile()) {
    if (currentStyleType !== "mobile") {
      // 卸载之前的样式
      if (currentStyleType === "pc") {
        const pcStyle = document.querySelector('link[href$="pc/index.css"]');
        console.log("查找 PC 端样式链接:", pcStyle);
        if (pcStyle) pcStyle.remove();
      }
      // 加载移动端样式
      await import("@/assets/styles/mobile/index.scss");
      currentStyleType = "mobile";
      console.log("加载移动端样式");
    }
  } else {
    if (currentStyleType !== "pc") {
      // 卸载之前的样式
      if (currentStyleType === "mobile") {
        const mobileStyle = document.querySelector(
          'link[href$="mobile/index.css"]'
        );
        console.log("查找移动端样式链接:", mobileStyle);
        if (mobileStyle) mobileStyle.remove();
      }
      // 加载 PC 端样式
      await import("@/assets/styles/pc/index.scss");
      currentStyleType = "pc";
      console.log("加载 PC 端样式");
    }
  }
}

// 页面加载时首次加载样式
loadStyle();

// 监听窗口大小变化事件
window.addEventListener("resize", loadStyle);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
